<template>
  <div class="caseDetails">
    <cus-title text="案例展示"></cus-title>
    <div class="caseDetails-content">
      <div class="content-title">
        {{ detailsObj.caseNote }}
      </div>
      <video
        v-if="detailsObj.videoFileId"
        controls
        style="width: 600px; height: 350px"
        :src="videoUrl"
        controlslist="nodownload"
      ></video>
      <div class="caseDetails-content-imgbox">
        <div class="imgbox-one imgBox-div" v-if="imageFileIdList.length == 1">
          <img :src="oneSrc" alt="" @click="imgTobig(oneSrc)"/>
          <span class="imgbox-fileName">{{ oneName }}</span>
        </div>
        <div class="imgbox-two" v-if="imageFileIdList.length == 2">
          <div v-for="(item, index) in imageBox" :key="index" class="imgBox-div">
            <img :src="item.src" alt="" @click="imgTobig(item.src)"/>
            <span class="imgbox-fileName">{{ item.fileName }}</span>
          </div>
        </div>
        <div class="imgbox-more" v-else>
          <div v-for="(item, index) in imageBox" :key="index" class="imgBox-div">
            <img :src="item.src" alt="" @click="imgTobig(item.src)"/>
            <span class="imgbox-fileName">{{ item.fileName }}</span>
          </div>
        </div>
      </div>
      <div v-html="detailsObj.caseRemark"></div>
    </div>
    <el-dialog :visible.sync="imgVisible" width="70%" top="0">
        <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
  </div>
</template>

<script>
import { findGwCaseDetail } from "@/api/case";
import { getFileById } from "@/api/common";
export default {
  data() {
    return {
      keyId: "",
      videoCoverFileId: 3,
      detailsObj: {},
      imageFileIdList: [],
      imageBox: [],
      oneSrc: "",
      oneName:"",
      videoUrl:"",
      dialogImageUrl:"",
      imgVisible:false,
    };
  },
  mounted() {
    this.keyId = this.$route.query.keyId;
    this.imageBox = [];
    this.findGwCaseDetail();
  },
  methods: {
    async findGwCaseDetail() {
      const res = await findGwCaseDetail({ keyId: this.keyId });
      console.log(res);
      this.detailsObj = res.data.detail;
      this.imageFileIdList = this.detailsObj.images;
      console.log(this.imageFileIdList);
      //1:封面图;2:配图;31:视频封面图;32:视频文件
      this.imageFileIdList.forEach((v) => {
        this.getFileById(v.key, 2, v);
      });
      if (this.detailsObj && this.detailsObj.videoFileId) {
        this.getFileById(this.detailsObj.videoFileId, 32);
      } else if (this.detailsObj && this.detailsObj.videoCoverFileId) {
        this.getFileById(this.detailsObj.videoCoverFileId, 31);
      }
    },
    async getFileById(fileId,fileFlag,item) {
      const res = await getFileById({
        fileId: fileId,
        moduleFlag:'case',
        downFlag:0
      });
      if (fileFlag !== 32) {
        const src =
          "data:image/png;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
        if (this.imageFileIdList.length == 1) {
          this.oneSrc = src;
          this.oneName = item.value
        } else {
          this.imageBox.push({
            src: src,
            fileName: item.value
          });
        }
      }else{
        this.videoUrl =
          "data:video/mp4;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      }
    },
    imgTobig(src){
        this.dialogImageUrl = src
        this.imgVisible = true
    }
  },
};
</script>

<style lang="less" scoped>
.caseDetails {
  width: 1400px;
  padding: 20px 129px;
  box-sizing: border-box;
  background: #fff;
  .caseDetails-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .content-title {
      margin: 30px 0;
    }
    .caseDetails-content-imgbox {
      margin: 30px 0;

      .imgbox-one {
        width: 600px;
        height: 350px;
        margin-left: 200px;
        > img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .imgbox-two {
        display: flex;
        flex-wrap: wrap;
        > div {
          width: 400px;
          height: 250px;
          margin: 0 10px;
          > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .imgbox-more {
        display: flex;
        flex-wrap: wrap;
        width: 1000px;
        > div {
          width: 300px;
          height: 200px;
          margin-left: 33px;
          margin-bottom: 20px;
          > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .imgBox-div{
        position: relative;
      }
      .imgbox-fileName{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 26px;
        background: #a30014;
        text-align: center;
        line-height: 26px;
        color: #fff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/case/caseDetails.vue